"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "EmailTokenModel", {
    enumerable: true,
    get: function() {
        return EmailTokenModel;
    }
});
const _bson = require("bson");
const _zod = require("zod");
const EmailTokenModel = _zod.z.object({
    _id: _zod.z.instanceof(_bson.ObjectId),
    email: _zod.z.string(),
    token: _zod.z.string(),
    user_id: _zod.z.instanceof(_bson.ObjectId)
});
